import appSettings from 'wanderu-config';

import EventQueue from './EventQueue';
import FailedEventStorage from './FailedEventStorage';
import EventTransporters from './eventTransporters';

let eventsProcessingInterval = 1000;
let retryAttempts = 5;

function configure(config) {
    eventsProcessingInterval = config.eventsProcessingInterval;
    retryAttempts = config.eventsProcessingRetryAttempts;
}

function start() {
    let failedEvents = FailedEventStorage.removeFailedEvents();

    // If there are over 100 failed events waiting to be run,
    // probably something worse happened. We will just discard them for good.
    if (failedEvents.length < 100) {
        EventQueue.enqueueEvents(failedEvents);
    }
    setInterval(_processQueue, eventsProcessingInterval);
}

function sendBeacon() {
    if (appSettings.env.isClient && window.navigator && window.navigator.sendBeacon) {
        const events = _getWrappedEvents().map(({ event }) => event);
        return EventTransporters.BeaconEventTransporter.sendEvents(events);
    }

    return _processQueue();
}

function _processQueue() {
    if (!EventQueue.hasEvents()) {
        return;
    }

    if (appSettings.env.isClient && window.requestIdleCallback) {
        // Wait at most two seconds before processing events.
        window.requestIdleCallback(_processPendingAnalyticsEvents, { timeout: 2000 });
    } else {
        _processPendingAnalyticsEvents();
    }
}

async function _processPendingAnalyticsEvents() {
    const wrappedEvents = _getWrappedEvents();

    try {
        await EventTransporters.HttpEventTransporter.sendEvents(
            wrappedEvents.map(({ event }) => event),
        );
    } catch (ex) {
        const updatedEvents = wrappedEvents.map(({ attempts, event }) => ({
            attempts: attempts + 1,
            event,
        }));

        const failedWrappedEvents = updatedEvents
            .filter(({ attempts }) => attempts > retryAttempts);

        if (failedWrappedEvents.length) {
            FailedEventStorage
                .saveFailedEvents(failedWrappedEvents.map(({ event }) => event));
        }

        const wrappedEventsToEnqueue = updatedEvents
            .filter(({ attempts }) => attempts <= retryAttempts);

        EventQueue.enqueueEvents(wrappedEventsToEnqueue);
    }
}

function _getWrappedEvents() {
    return EventQueue.dequeueAllEvents().map((event) => {
        if (event.attempts !== undefined) {
            return event;
        }

        return {
            attempts: 1,
            event,
        };
    });
}

export { configure };
export { sendBeacon };
export { start };

export default {
    start,
    sendBeacon,
    configure,
};
